import React, { useCallback, useEffect, useState } from 'react';
import lodash from 'lodash';
import PropTypes from 'prop-types';

const withNumberInput = (NumberInputComponent) => {
   const WrappedComponent = (props) => {
      const [errorMessage, setErrorMessage] = useState();

      useEffect(() => {
         // Used for getting the errorMessage when NumberInput component is used as a FieldArray Field
         const nameParts = props.field.name.split(/\]\.|\.|\[|\]/);

         let errorPtr = props.form.errors;

         if (errorPtr) {
            for (let i = 0; i < nameParts.length; i++) {
               const name = nameParts[i];
               if (lodash.isObject(errorPtr)) {
                  errorPtr = errorPtr[name];
               } else {
                  break;
               }
            }
         }

         if (typeof errorPtr === 'string' || typeof errorPtr === 'undefined') {
            setErrorMessage(errorPtr);
         }
      }, [JSON.stringify(props.form.errors)]);

      const onChangeNonEvent = useCallback((newInputValue) => {
         props.form.setFieldValue(props.field.name, newInputValue);
      }, []);

      return (
         <NumberInputComponent
            {...props.field}
            onChangeNonEvent={onChangeNonEvent}
            min={props.min}
            max={props.max}
            step={props.step}
            isDisabled={props.isDisabled}
            isValueHiddenWhenDisabled={props.isValueHiddenWhenDisabled}
            isNegativeAllowed={props.isNegativeAllowed}
            isTouched={props.form.touched[props.field.name]}
            errorMessage={errorMessage}
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.object.isRequired,
         errors: PropTypes.object.isRequired,
         setFieldValue: PropTypes.func.isRequired,
      }).isRequired,
      min: PropTypes.string,
      max: PropTypes.string,
      step: PropTypes.string,
      isDisabled: PropTypes.bool,
      isValueHiddenWhenDisabled: PropTypes.bool,
      isNegativeAllowed: PropTypes.bool,
   };

   WrappedComponent.defaultProps = {
      min: undefined,
      max: undefined,
      step: undefined,
      isDisabled: false,
      isValueHiddenWhenDisabled: false,
      isNegativeAllowed: false,
   };

   return WrappedComponent;
};

export default withNumberInput;
